import { Button } from '@mui/material';
import style from './Buttons.module.css';
import { useEffect, useRef } from 'react';

export default function Buttons({ button1, button2 }) {
    const containerRef = useRef(null);
    const sentinelRef = useRef(null);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                const container = containerRef.current;
                if (!container) return;
                
                if (!entry.isIntersecting) {
                    container.classList.add(style.stickyActive);
                } else {
                    container.classList.remove(style.stickyActive);
                }
            },
            { 
                threshold: [0],
                rootMargin: '-1px 0px 0px 0px'
            }
        );

        observer.observe(sentinel);

        return () => {
            if (sentinel) {
                observer.unobserve(sentinel);
            }
        };
    }, []);

    return (
        <>
            <div ref={sentinelRef} className={style.sentinel} />
            <div ref={containerRef} className={style.container}>
                <Button
                    className={`${style.button} ${style.first}`}
                    variant="contained"
                    color="primaryDark"
                    onClick={button1?.onClick}
                    loading={button1?.loading}
                    disabled={button1?.disabled}
                    sx={!button1?.loading && (
                        {
                            boxShadow: '#fff20073 0px 0px 14px 0px',
                            '&:hover': {
                            boxShadow: '#fff20073 0px 0px 20px 0px'
                            }
                        }
                    )}
                >
                    {button1?.text}
                </Button>
                {button2 && (
                    <Button
                        className={`${style.button} ${style.second}`}
                        variant="contained"
                        color="primaryDarkOut"
                        onClick={button2?.onClick}
                        loading={button2?.loading}
                    >
                        {button2?.text}
                    </Button>
                )}
            </div>
        </>
    )
}